<template>
  <div>
    <IntentDetail
      v-if="pageStatus === 'intentDetail'"
      :toDetailData="toDetailData"
      @changeToLeader="changeToLeader()"
    ></IntentDetail>
    <IntentLeader
      v-if="pageStatus === 'leader'"
      :toLedgerData="toLedgerData"
      @changeToDetail="changeToDetail"
    ></IntentLeader>
  </div>
</template>
<script>
import IntentDetail from "./intentDetail/IntentDetail";
import IntentLeader from "./intentLeader/IntentLeader";
export default {
  name: "IntentRelease",
  components: {
    IntentDetail,
    IntentLeader,
  },
  data() {
    return {
      pageStatus: "leader",
      toDetailData: {},
      toLedgerData: {
        page: 1,
        pageSize: 10,
        queryProjectStatus: undefined,
        queryProjectName: undefined,
      },
    };
  },
  methods: {
    changeToLeader() {
      this.pageStatus = "leader";
    },
    changeToDetail(val) {
      this.toLedgerData.page = val.page;
      this.toLedgerData.pageSize = val.pageSize;
      this.toLedgerData.queryProjectStatus = val.queryProjectStatus;
      this.toLedgerData.queryProjectName = val.queryProjectName;
      this.toDetailData = {
        webId: val.webId,
        projectStatus: val.projectStatus,
        isEditable: val.isEditable,
        selectHouseList: val.selectHouseList,
      };
      this.pageStatus = "intentDetail";
    },
  },
};
</script>

<style>
</style>